export default __webpack_public_path__ + "static/media/discord.052750eb.svg";